import rentObjectTypesService from "@/services/rentObjectTypesService";

const state = () => ({
  all: [],
  single: null,
  columns: []
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await rentObjectTypesService.create(formData);
      dispatch(
        "common/showSuccess",
        `${res.data.name} wurde erfolgreich erstellt.`,
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekttyp konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await rentObjectTypesService.findAll();
      commit("setAllRentObjectTypes", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekttypen konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAllFull({ commit, dispatch }) {
    try {
      const res = await rentObjectTypesService.findAllFull();
      commit("setAllRentObjectTypes", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekttypen konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    try {
      const res = await rentObjectTypesService.findOne({ id });
      commit("setSingleRentObjectTypes", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Objekt konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectTypesService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Objekt konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, { id, name, icon, layout }) {
    try {
      const res = await rentObjectTypesService.update({ id, name, icon, layout });
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        `${res.data.name} wurde erfolgreich erstellt.`,
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Objekt konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateDocumentContent({ dispatch }, formData) {
    try {
      await rentObjectTypesService.updateDocumentContent(formData);
      dispatch(
        "common/showSuccess",
        "Objekttyp-Inhalte wurden aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Objekttyp-Inhalte wurden leider nicht aktualisiert.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateColors({ dispatch }, formData) {
    try {
      await rentObjectTypesService.updateColors(formData);
      dispatch(
        "common/showSuccess",
        "Objekttyp-Farben wurden aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Objekttyp-Farben wurden leider nicht aktualisiert.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async getColumns({ commit, dispatch }) {
    try {
      const res = await rentObjectTypesService.getColumns();
      commit("setColumns", res.data)
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Spalten konnten konnten nicht gefunden werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
  getById: (state) => (id) => {
    return state.all.find(type => type.id == id)
  },
};

const mutations = {
  setAllRentObjectTypes(state, object) {
    state.all = object;
  },
  setSingleRentObjectTypes(state, object) {
    state.single = object;
  },
  setColumns(state, columns) {
    state.columns = columns;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
